export default __webpack_public_path__ + "static/media/arche_logo.aea3b926.png";